import { useParams, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { findTool, userTools } from "@/lib/tools";

/**
 * Generic embed page for optional tools. Loads the tool's static HTML in an
 * iframe at full viewport. Renders inside the authenticated `Layout` (sidebar
 * still visible) so users can navigate back without losing context.
 */
export default function ToolEmbed() {
  const { slug } = useParams();
  const { user } = useAuth();
  const tool = findTool(slug);

  if (!tool) return <Navigate to="/app" replace />;

  const enabled = userTools(user).some((t) => t.id === tool.id);
  if (!enabled) {
    return (
      <div className="p-8 lg:p-12 max-w-3xl mx-auto" data-testid="tool-locked">
        <div className="overline mb-2 text-amber-700">Acesso restrito</div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">{tool.label}</h1>
        <p className="text-slate-600 mt-3 leading-relaxed">{tool.description}</p>
        <div className="card mt-6 border-amber-300 bg-amber-50">
          <div className="flex items-start gap-3">
            <i className="fa-solid fa-lock text-amber-700 text-lg mt-0.5"></i>
            <div className="text-sm text-amber-900 leading-relaxed">
              Esta ferramenta não está habilitada para sua conta. Solicite ao administrador
              Sollute para liberar o acesso pelo painel <strong>Administração → Usuários</strong>.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 bg-white" data-testid={`tool-embed-${slug}`}>
      <iframe
        src={tool.htmlPath}
        title={tool.label}
        className="block w-full h-full border-0"
        // Storage access is needed because the tool uses localStorage.
        // sandbox attribute would break localStorage; we trust the bundled
        // HTML (we control it).
        allow="clipboard-read; clipboard-write; storage-access"
      />
    </div>
  );
}
